import React, {Component} from 'react';
import {withStyles, TextField, Button, Container} from '@material-ui/core';
import {connect} from 'react-redux';
import {Dispatch} from 'redux';
import { ITag } from '../../core/models/tag';
import { ADD_TAG, UPDATE_TAG } from '../../core/handlers.actions';

const styles = (theme:any) => ({
    root: {'& .MuiTextField-root': {margin: theme.spacing(3), width: '100%'}},
    editBox: {borderTop: '2px solid #f50057', borderLeft: '2px solid #f50057', borderRight: '2px solid #f50057'}
});

interface Props {
    classes: any;
    addTag: (data:ITag) => void;
    edit: boolean;
    current?: any;
    updateTag: (data:ITag) => void;
    action: () => void;
}
interface State {
   name: string | null,
   description: string | null,
   slug: string | null;
   error:boolean;
   _id: string | null;
   editing: boolean;
}

class TagForm extends Component<Props, State>{   
    state:State =  {name: '', description: '', slug: '', error: false, _id: null, editing: false};

    constructor(props:Props){
        super(props);        
        this.validateForm = this.validateForm.bind(this);
        this.inputChangeHandler = this.inputChangeHandler.bind(this);
        this.stringToSlug = this.stringToSlug.bind(this);
        this.submit = this.submit.bind(this);
        this.update = this.update.bind(this);
        this.cancel = this.cancel.bind(this);
    }

    public componentDidUpdate(){
        const {edit, current} = this.props;     
        const {editing} = this.state;           
        if(edit && !editing) this.setState({...this.state, _id:current?._id, name: current?.name, description: current?.description, slug: current?.slug, editing: true});
    }

    public inputChangeHandler(e:any){
        const {name, value} = e.target; 
        if(name === 'name') return this.setState({...this.state, [name]: value, slug: this.stringToSlug(value)});      
        return this.setState({...this.state, [name] : value});
    }

    public validateForm(){
        const {name} = this.state;
        return name !== '' && name !== null;
    }

    public stringToSlug(str:string) {
        str = str.replace(/^\s+|\s+$/g, ''); // trim
        str = str.toLowerCase();
        
        // remove accents, swap ñ for n, etc
        var from = "àáäâèéëêìíïîòóöôùúüûñç·/_,:;";
        var to   = "aaaaeeeeiiiioooouuuunc------";
        for (var i=0, l=from.length ; i<l ; i++) {
          str = str.replace(new RegExp(from.charAt(i), 'g'), to.charAt(i));
        }
      
        str = str.replace(/[^a-z0-9 -]/g, '') // remove invalid chars
          .replace(/\s+/g, '-') // collapse whitespace and replace by -
          .replace(/-+/g, '-'); // collapse dashes        
        return str;
      }

    public submit(){
        const {addTag} = this.props;
        const {name, description, slug} = this.state;
        if(!this.validateForm()) return this.setState({...this.state, error: true});
        addTag({name, description, slug} as ITag);
        this.setState({...this.state, name: '', description: '', error: false, slug: ''});
    }
    public update(){
        const {updateTag, action} = this.props;
        const {_id, name, description, slug} = this.state;
        if(!this.validateForm()) return this.setState({...this.state, error: true});        
        updateTag({_id, name, description, slug} as ITag);  
        this.setState({...this.state, name: '', description: '', slug: '', error: false, _id: null, editing: false});
        action();       
    }

    public cancel(){
        const { action} = this.props;
        this.setState({...this.state, name: '', description: '', slug: '', error: false, _id: null, editing: false});
        action();  
    }

    public render(){
        const {classes} = this.props;
        const {name, description, slug, error, editing} =  this.state;
        
        return(
            <form className={classes.root} noValidate autoComplete="off">
                {editing? <h2>Update Tag</h2>: <h2>Add New Tag</h2>}
                <Container>
                    <TextField error={error} required name="name" label="Name" value={name} onChange={this.inputChangeHandler}/>
                    <TextField label="Description" name="description" value={description} onChange={this.inputChangeHandler}/>
                    <TextField name="slug" value={slug} />
                    {editing?<div><Button variant="contained" color="primary" onClick={this.update}>Update Tag</Button>&nbsp;&nbsp;<Button variant="contained" color="secondary" onClick={this.cancel}>Cancel</Button></div>: <div><Button variant="contained" color="primary" onClick={this.submit}>Add Tag</Button>&nbsp;&nbsp;<Button variant="contained" color="secondary" onClick={this.cancel}>Cancel</Button></div>}
                </Container>              
            </form>
        );
        
    }
}
const actions = (dispatch:Dispatch) => ({ 
    addTag: (data:ITag) => dispatch({type: ADD_TAG, payload: data}),
    updateTag: (data:ITag) => dispatch({type: UPDATE_TAG, payload: data})
});
export default connect(null, actions)(withStyles(styles)(TagForm));